import { globalHive } from '../../src/modules/hive'
import { cancelReport } from '../../src/redux/actions/activity'
import { Acti_CANCEL_REPORT } from './Acti.constants'
import { Acti_deleteActivitiesOverwrite } from './Acti.deleteActivitiesOverwrite'
import { Acti_dispatch } from './Acti.dispatch'
import { IDB_taskReportsDeleteAll } from '../IDB/IDB.table.taskReport'
import { Logg_event } from '../Logg/Logg.event'
import { Rpts_openReportClear } from '../Rpts/Rpts.OpenReport'
import { Rpts_clearReportStatuses } from '../Rpts/Rpts.reportStatus'
import { Unit_deleteAllRoutedUnits } from '../Unit/Unit.unitRouting'

export async function Acti_cancelActivity() {
    Logg_event('Start', { label: 'activity.cancelActivity' })

    await Unit_deleteAllRoutedUnits()
    await Acti_deleteActivitiesOverwrite()
    await Rpts_clearReportStatuses()
    await IDB_taskReportsDeleteAll()
    await Rpts_openReportClear()

    Acti_dispatch({ actionType: Acti_CANCEL_REPORT })
    globalHive.dispatch(cancelReport())
}
